<template>
  <div style="max-width: 100%; width: 525px;" class="mb-8">
    <v-alert
      v-if="verificationStatus != 0"
      :type="alertType"
      dense
      text
      border="left"
    >
      {{ alertMessage }}
    </v-alert>
    <div>
      <p class="mb-4">
        {{ $t("verification.bank.description") }}
      </p>
      <v-form
        v-model="bankVerificationForm"
        @submit="editPlayerAndVerifyBank"
        :disabled="disableForm || validatingBank || verificationStatus == 2"
      >
        <v-autocomplete
          v-model="form.bank"
          :items="banks"
          :rules="[rules.required]"
          label="Selecionar Banco"
          outlined
          required
          item-text="text"
          item-value="value"
          no-data-text="Nenhum banco encontrado"
          return-object
          :disabled="pixEditBlocked || loading"
          :loading="loading"
          clearable
        ></v-autocomplete>

        <v-select
          v-model="form.keyType"
          :rules="[rules.required]"
          label="Tipo da Chave Pix"
          outlined
          required
          :disabled="pixEditBlocked || loading"
          :loading="loading"
          :items="keyTypeOptions"
          item-text="label"
          item-value="value"
          @change="onTypePixChange"
        ></v-select>

        <!-- Tipo E-mail -->
        <v-text-field
          v-if="form.keyType == 'EMAIL'"
          v-model="form.key"
          :label="labelKeyPix"
          :placeholder="placeholderPix"
          :disabled="pixEditBlocked"
          outlined
          required
          type="email"
          :rules="[rules.required]"
          clearable
        ></v-text-field>

        <!-- Tipo CPF EVP AND PHONE -->
        <v-text-field
          v-model="form.key"
          :label="labelKeyPix || 'Chave Pix'"
          :placeholder="placeholderPix"
          :disabled="form.keyType === 'CPF' || pixEditBlocked || loading"
          outlined
          required
          v-mask="maskPix"
          :rules="[rules.required]"
          :loading="loading"
          v-else
          clearable
        ></v-text-field>
        <div>
          <v-btn
            class="primary"
            type="submit"
            @click.prevent="editPlayerAndVerifyBank"
            :disabled="
              verificationStatus == '2' ||
                !bankVerificationForm ||
                loading ||
                validatingBank
            "
            :loading="validatingBank"
          >
            {{ $t("btnSend") }}
          </v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import { validate } from "@/util/form-validate";

export default {
  props: ["verificationStatus"],

  data: () => ({
    checkVerificationIntervalId: 0,

    banks: [],

    bankVerificationForm: false,

    form: {
      bank: "",
      keyType: "",
      key: "",
    },

    initialForm: {
      bank: "",
      keyType: "",
      key: "",
    },

    keyTypeOptions: [
      {
        label: "CPF",
        value: "CPF",
      },
      {
        label: "E-mail",
        value: "EMAIL",
      },
      {
        label: "Telefone",
        value: "PHONE",
      },
      {
        label: "Chave aleatória",
        value: "EVP",
      },
    ],

    userInfo: {},

    rules: {
      required: validate.required,
    },

    labelKeyPix: "",
    maskPix: undefined,
    placeholderPix: "",

    pixEditBlocked: false,

    loading: true,

    validatingBank: false,
  }),

  computed: {
    showAlert() {
      return (
        this.verificationStatus == "2" ||
        this.verificationStatus == "3" ||
        this.pixEditBlocked
      );
    },
    alertMessage() {
      if (this.verificationStatus == "1") {
        return this.$t("verification.bank.alert.success");
      }

      if (this.verificationStatus == "2") {
        return this.$t("verification.bank.alert.inProgress");
      }

      if (this.verificationStatus == "3") {
        return this.$t("profileBankVerificationDenied");
      }

      if (this.pixEditBlocked) {
        return this.$t("pixEditBlocked");
      }

      return "";
    },
    alertType() {
      if (this.verificationStatus == "1") {
        return "success";
      }

      if (this.verificationStatus == "2") {
        return "info";
      }

      if (this.verificationStatus == "3") {
        return "error";
      }

      if (this.pixEditBlocked) {
        return "warning";
      }

      return "";
    },
    disableForm() {
      return this.verificationStatus == "2" || this.pixEditBlocked;
    },
  },

  created() {
    this.getPlayerAndFetchBanks();
  },

  destroyed() {
    clearInterval(this.checkVerificationIntervalId);
  },

  methods: {
    editPlayerAndVerifyBank() {
      if (this.pixEditBlocked) {
        this.$store.commit("setNotification", {
          msg: this.$t("pixEditBlocked"),
          color: "warning",
        });

        return;
      }

      this.validatingBank = true;

      const original = this.form.key;

      if (this.form.keyType == "CPF") {
        this.form.key = this.form.key.replace(/[^0-9]+/g, "");
      }
      if (this.form.keyType == "PHONE") {
        this.form.key = this.form.key.replace(/[^0-9]+/g, "");
        this.form.key = `+55${this.form.key}`;
      }

      const data = {
        etapa: "Banco",
        tipo_chave: this.form.keyType,
        chave: this.form.key,
        codigo_banco: this.form.bank.value,
      };

      this.$axios
        .put("player/profile/editPlayer", qs.stringify(data), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then(async () => {
          //   this.$store.commit("setNotification", {
          //     msg: res.data.messages,
          //     color: "success",
          //   });

          this.$gtag.add_payment_info({
            type: this.form.keyType,
            key: this.form.key,
          });

          await this.doBankVerification(original);
        })
        .catch((err) => {
          this.$store.commit("setNotification", {
            msg: err.response.data.messages.error,
            color: "warning",
          });

          this.validatingBank = false;
        });
    },

    doBankVerification(original) {

      this.$axios
        .get("/player/online/bank/validateBank")
        .then((res) => {
          this.$emit("changeBankVerificationStatus", 2);

          this.$store.commit("setNotification", {
            msg: res.data.messages,
            color: "success",
          });

          this.checkVerificationIntervalId = setInterval(() => {
            this.getBankVerificationPlayer();
          }, 5000);
        })
        .catch((err) => {
          this.$store.commit("setNotification", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
        })
        .finally(() => {
          this.validatingBank = false;

          this.form.key = original;
        });
    },

    getBankVerificationPlayer() {
      this.$axios
        .get("/player/online/bank/playerVerificationBank")
        .then((response) => {
          const currentStatus = response.data.dados.verificacao_bancaria;
          this.$emit("changeBankVerificationStatus", currentStatus);
          if (currentStatus != "2") {
            clearInterval(this.checkVerificationIntervalId);
          }
        });
    },

    getPlayerAndFetchBanks() {
      this.$axios.get("player/profile/getPlayer").then((response) => {
        this.userInfo = response.data.dados;

        if (!this.userInfo.tipo_chave && !this.userInfo.chave_pix) {
          this.pixEditBlocked = false;
        } else {
          this.pixEditBlocked = response.data.block_pix == "1";
        }

        this.form.keyType = this.userInfo.tipo_chave;
        this.form.key = this.userInfo.chave_pix;

        if (this.form.keyType === "CPF") {
          this.form.key = this.userInfo.cpf.replace(
            /(\d{3})(\d{3})(\d{3})(\d{2})/,
            "$1.$2.$3-$4"
          );
        } else if (!this.form.keyType) {
          this.form.keyType = "CPF";
          this.maskPix = "###.###.###-##";
          this.$nextTick(() => {
            this.form.key = this.userInfo.cpf.replace(
              /(\d{3})(\d{3})(\d{3})(\d{2})/,
              "$1.$2.$3-$4"
            );
          });
          this.labelKeyPix = "CPF";
          this.placeholderPix = "000.000.000-00";
        } else if (this.form.keyType === "PHONE") {
          this.form.keyType = "PHONE";
          this.maskPix = "(##)#####-####";
          this.labelKeyPix = "Telefone";
          this.placeholderPix = "Ex: (11) 99999-9999";
          this.$nextTick(() => {
            this.form.key = response.data.dados.chave_pix
              .replace(/d{2}(\d{2})(\d{5})(\d{4})/, "($2)$3-$4")
              .split("+55")[1];
          });
        } else if (this.form.keyType === "EVP") {
          this.maskPix = false;
          this.labelKeyPix = "Chave aleatória";
          this.typePix = "string";
        }

        this.$axios
          .get("/player/online/bank/listBanksOperator")
          .then((res) => {
            this.banks = res.data.dados.map((bank) => ({
              text: `${bank.cod_bank} - ${bank.nome_curto}`,
              value: bank.cod_bank,
            }));

            const bank = this.banks.find(
              (bank) => bank.value == response.data.dados.codigo_banco
            );

            this.form.bank = bank;
            this.initialForm = { ...this.form };
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    onTypePixChange(val) {
      if (!val) {
        return;
      }

      if (val == "CPF") {
        this.maskPix = "###.###.###-##";
        this.form.keyType = "CPF";
        this.labelKeyPix = "CPF";
        this.placeholderPix = "000.000.000-00";
        this.$nextTick(() => {
          this.form.key = this.userInfo.cpf.replace(
            /(\d{3})(\d{3})(\d{3})(\d{2})/,
            "$1.$2.$3-$4"
          );
        });
      }

      if (val === "EMAIL") {
        this.form.key = "";
        this.labelKeyPix = "Email";
        this.maskPix = undefined;
        this.placeholderPix = "Ex: myemail@email.com";
      }

      if (val === "PHONE") {
        this.form.key = "";
        this.labelKeyPix = "Telefone";
        this.maskPix = "(##)#####-####";
        this.placeholderPix = "Ex: (11) 99999-9999";
      }

      if (val === "EVP") {
        this.form.key = "";
        this.labelKeyPix = "EVP - Código Aleatório";
        this.maskPix = "";
        this.placeholderPix = "";
      }
    },
  },
};
</script>
<style>
.v-alert i {
  align-self: center;
}
</style>
